import React, { useEffect, useState, useRef } from "react";
import validator from "validator";
import Leftsiderbar from "../home/allcmp/Leftsidebar";
import { makeStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
  Typography,
} from "@material-ui/core";
import MaterialTable from "material-table";
import Top from "../Top";
import { API_URL } from "../../../config";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import EditDevice from "./EditDevice";
import Viewlog from "./Viewlog";
import Viewlinkedlog from "./Viewlinkedlog";
import logimg from "../../images/log.png";
import { useNavigate, Link } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GoDeviceDistributors from "./GoDeviceDistributors";
import GoDeviceOwner from "./GoDeviceOWner";
import GoDeviceAccordian6 from "./GoDeviceAccordian6";
import GoDeviceOwnerAcc6 from "./GoDeviceOwnerAcc6";
import GoDeviceAccordian5 from "./GoDeviceAccordian5";
import GodeviceOwnerAccordian5 from "./GodeviceOwnerAccordian5";
import ChangeDistributor7 from "./ChangeDistributor7";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
}));

const Godevices = () => {
  const classes = useStyles();
  const navigation = useNavigate();
  const location = useLocation();
  const id = localStorage.getItem("user_id");
  let dist = new URLSearchParams(window.location.search).get("dist");
  let owner = new URLSearchParams(window.location.search).get("owner");
  const deviceType = new URLSearchParams(window.location.search).get(
    "device_type"
  );
  const user_type = localStorage.getItem("user_type");

  const [data, setData] = useState([]);

  const [confirmKey, setConfirmKey] = useState(false);
  const [transferDistributor, setTransferDistributor] = useState("");

  const [firstName1, setFirstName1] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password1, setPassword1] = useState("");
  const [telephone1, setTelephone1] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [age, setAge] = useState("");
  const [country, setCountry] = useState("");
  const [business, setBusiness] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [state, setState] = useState("");
  const [stateId, setStateId] = useState("");
  const [gender, setGender] = useState("");
  const [GoToggle, setGoToggle] = useState(false);
  const [Device5, setDevice5] = useState(false);
  const [Device6, setDevice6] = useState(false);
  const [distList, setDistList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [distId, setDistId] = useState(null);
  const [ownerId, setOwnerId] = useState(null);
  const [filterDist, setFilterDist] = useState("");
  const [filterOwner, setFilterOwner] = useState("");
  const [passShow, setPassShow] = useState(false);

  const [checkboxshow, setCheckboxshow] = useState(false);
  const [cmoduleval, setCmoduleval] = useState(0);
  const [mmoduleval, setMmoduleval] = useState(0);
  const [serialkeyval, setSerialkeyval] = useState(null);
  const [confirmpasserror, setConfirmpasserror] = useState("");
  const [confirmSerialkeyval, setConfirmSerialkeyval] = useState("");
  const [devicetype, setDevicetype] = useState(0);
  const [checkingboxmessge, setCheckingboxmessge] = useState(false);

  const serialkey = useRef();
  const confirmserialkey = useRef();
  const device_type = useRef();
  const cmodule = useRef();
  const m_module = useRef();
  const [errorMessege, setErrorMessege] = useState(false);
  const [deviceid, setDeviceid] = useState(null);
  const [selSerialKey, setSelSerialKey] = useState(null);

  const [serialkeyes, setSerialkey] = useState(null);

  const [deviceModal, setDeviceModal] = useState(false);
  const [distributorDeviceModal, setdistributorDeviceModal] = useState(false);
  const [ownerDeviceModal, setownerDeviceModal] = useState(false);
  const deviceToggleModal = () => {
    setConfirmKey(false);
    setDeviceModal(!deviceModal);
  };
  const distributorDeviceToggleModal = () => {
    setdistributorDeviceModal(!distributorDeviceModal);
    if (passShow) {
      setPassShow(!passShow);
    }
    const distributor = localStorage.getItem("distributor_change");
    const customer = localStorage.getItem("customer_change");
    const devices = localStorage.getItem("Device_change");
    if (distributor == null && customer == null && devices == null) {
      localStorage.removeItem("distributor_change");
      localStorage.removeItem("customer_change");
      localStorage.removeItem("Device_change");
    }
    if (distributor != null && customer != null && devices != null) {
      if (distributor == "all" && customer == "all" && devices == "all") {
        navigation(
          `${location.pathname}` +
            "?dist=" +
            `${distributor}` +
            "&owner=" +
            `${customer}` +
            "&device_type=" +
            `${devices}`
        );
      } else {
        ownerList?.map((item) => {
          if (item.owner_id == customer) {
            navigation(
              `${location.pathname}` +
                "?dist=" +
                `${distributor}` +
                "&owner=" +
                `${customer}` +
                "&device_type=" +
                `${devices}`
            );
          } else {
            navigation(
              `${location.pathname}` +
                "?dist=" +
                `${distributor}` +
                "&device_type=" +
                `${devices}`
            );
          }
        });
      }
    } else if (distributor == null && customer != null && devices == null) {
      navigation(
        `${location.pathname}` + "?dist=" + `${id}` + "&owner=" + `${customer}`
      );
    } else if (distributor == null && customer != null && devices != null) {
      navigation(
        `${location.pathname}` +
          "?dist=" +
          `${id}` +
          "&owner=" +
          `${customer}` +
          "&device_type=" +
          `${devices}`
      );
    } else if (distributor == null && customer != null && devices != null) {
      navigation(
        `${location.pathname}` +
          "?dist=" +
          `${id}` +
          "&owner=" +
          `${customer}` +
          "&device_type=" +
          `${devices}`
      );
    } else if (distributor != null && customer == null && devices != null) {
      navigation(
        `${location.pathname}` +
          "?dist=" +
          `${distributor}` +
          "&device_type=" +
          `${devices}`
      );
    } else if (distributor == null && customer == null && devices != null) {
      navigation(
        `${location.pathname}` +
          "?dist=" +
          `${id}` +
          "&device_type=" +
          `${devices}`
      );
    } else if (distributor != null && customer != null && devices == null) {
      navigation(
        `${location.pathname}` +
          "?dist=" +
          `${distributor}` +
          "&owner=" +
          `${customer}`
      );
    } else if (distributor != null && customer == null && devices == null) {
      navigation(`${location.pathname}` + "?dist=" + `${distributor}`);
    } else {
      let id = localStorage.getItem("user_id");
      navigation(`${location.pathname}` + "?dist=" + `${id}`);
    }
  };
  const ownerDeviceToggleModal = () => {
    setownerDeviceModal(!ownerDeviceModal);
    if (passShow) {
      setPassShow(!passShow);
    }
    const distributor = localStorage.getItem("distributor_change");
    const customer = localStorage.getItem("customer_change");
    const devices = localStorage.getItem("Device_change");
    if (distributor == null && customer == null && devices == null) {
      navigation(`${location.pathname}` + "?dist=" + `${id}`);
    } else if (customer != null) {
      if (
        distributor == null &&
        customer != null &&
        customer != "all" &&
        devices != null &&
        devices != "all"
      ) {
        navigation(
          `${location.pathname}` +
            "?dist=" +
            `${id}` +
            "&owner=" +
            `${customer}` +
            "&device_type=" +
            `${devices}`
        );
      } else if (distributor == null && customer != null && customer == "all") {
        navigation(
          `${location.pathname}` +
            "?dist=" +
            `${id}` +
            "&owner=" +
            `${customer}`
        );
      } else if (distributor != null && customer != null && devices != null) {
        if (distributor == "all" && customer == "all" && devices == "all") {
          navigation(
            `${location.pathname}` +
              "?dist=" +
              `${distributor}` +
              "&owner=" +
              `${customer}` +
              "&device_type=" +
              `${devices}`
          );
        } else {
          if (ownerList?.some((e) => e.owner_id == customer)) {
            navigation(
              `${location.pathname}` +
                "?dist=" +
                `${distributor}` +
                "&owner=" +
                `${customer}` +
                "&device_type=" +
                `${devices}`
            );
          } else {
            navigation(
              `${location.pathname}` +
                "?dist=" +
                `${distributor}` +
                "&device_type=" +
                `${devices}`
            );
          }
        }
      } else if (distributor == null && customer != null && devices == "all") {
        navigation(
          `${location.pathname}` +
            "?dist=" +
            `${id}` +
            "&owner=" +
            `${customer}`
        );
      } else if (distributor == null && customer != null && devices == null) {
        navigation(
          `${location.pathname}` +
            "?dist=" +
            `${id}` +
            "&owner=" +
            `${customer}`
        );
      } else {
        navigation(
          `${location.pathname}` +
            "?dist=" +
            `${distributor}` +
            "&owner=" +
            `${customer}`
        );
      }
    } else {
      if (customer == null && devices != null && distributor != null) {
        navigation(
          `${location.pathname}` +
            "?dist=" +
            `${distributor}` +
            "&device_type=" +
            `${devices}`
        );
      } else if (customer == null && devices != null && distributor == null) {
        navigation(
          `${location.pathname}` +
            "?dist=" +
            `${id}` +
            "&device_type=" +
            `${devices}`
        );
      } else {
        navigation(`${location.pathname}` + "?dist=" + `${distributor}`);
      }
    }
  };

  const [successModal, setSuccessModal] = useState(false);
  const successToggleModal = () => setSuccessModal(!successModal);

  const [deleteModal, setDeleteModal] = useState(false);
  const deleteToggleModal = () => setDeleteModal(!deleteModal);

  const [deletesuccessModal, setDeletesuccessModal] = useState(false);
  const deletesuccessToggleModal = () =>
    setDeletesuccessModal(!deletesuccessModal);

  const [editdeviceModal, setEditdeviceModal] = useState(false);
  const editdeviceToggleModal = () => setEditdeviceModal(!editdeviceModal);

  const [successeditdeviceModal, setSuccesseditdeviceModal] = useState(false);
  const successeditdeviceToggleModal = () =>
    setSuccesseditdeviceModal(!successeditdeviceModal);

  const [changedeviceModal, setChangedeviceModal] = useState(false);
  const successechangedeviceModal = () =>
    setChangedeviceModal(!changedeviceModal);

  const [deregistersuccessfulModal, setDeregistersuccessfulModal] =
    useState(false);
  const deregistersuccessfulToggleModal = () =>
    setDeregistersuccessfulModal(!deregistersuccessfulModal);

  const [devicekeyModal, setDevicekeyModal] = useState(false);
  const devicekeyToggleModal = () => setDevicekeyModal(!devicekeyModal);

  const [deregisterModal, setDeregisterModal] = useState(false);
  const deregisterToggleModal = () => setDeregisterModal(!deregisterModal);
  const [changeDistributorModal, setchangeDistributorModal] = useState(false);
  const changeDistributorToggleModal = () =>
    setchangeDistributorModal(!changeDistributorModal);

  const [ViewdeviceModal, setViewdeviceModal] = useState(false);
  const viewdeviceToggleModal = () => setViewdeviceModal(!ViewdeviceModal);

  const [viewlinkedModal, setViewlinkedModal] = useState(false);
  const ViewlinkedToggleModal = () => setViewlinkedModal(!viewlinkedModal);

  const [openExpiryUpdateModal, setOpenExpiryUpdateModal] = useState(false);
  const openExpiryUpdateToggleModal = () =>
    setOpenExpiryUpdateModal(!openExpiryUpdateModal);
  const [selectedDate, setSelectedDate] = useState(null);
  const [expirySuccessModal, setExpirySuccessModal] = useState(false);
  const expirySuccessToggleModal = () =>
    setExpirySuccessModal(!expirySuccessModal);

  const userid = localStorage.getItem("user_id");
  const [fetchdata, setFetchdata] = useState(true);
  const [dataload, setDataload] = useState(false);

  useEffect(() => {
    if (distList.length > 0 && dist != "all") {
      if (distList.some((e) => e.eid == dist)) {
      } else {
        navigation(`${location.pathname}` + "?dist=" + "all");
      }
    }
  }, [distList]);

  useEffect(() => {
    localStorage.removeItem("distributor_change");
    localStorage.removeItem("customer_change");
    localStorage.removeItem("Device_change");
  }, []);

  useEffect(() => {
    handleDistList();
    godevicelist();
    // if(){

    // }
  }, [dist, owner, deviceType]);

  const HandleCmodule = () => {
    if (cmodule.current.checked) {
      setCmoduleval(1);
    } else {
      setCmoduleval(0);
    }
  };
  const handleGoToggle = () => {
    setGoToggle(true);
  };
  const handleDevice5 = () => {
    setDevice5(true);
  };
  const handleDevice6 = () => {
    setDevice6(true);
  };

  const HandlemModule = () => {
    if (m_module.current.checked) {
      setMmoduleval(1);
    } else {
      setMmoduleval(0);
    }
  };
  const handleDistributor = (event, id) => {
    setDataload(true);
    setDistId(id);
    setFirstName1("");
    setLastName("");
    setPassword1("");
    setEmail("");
    setAddress1("");
    setAddress2("");
    setTelephone1("");
    setCity("");
    setPostalCode("");
    setBusiness("");
    setAge("");
    setGender("");
    const url = `/get/distributer/device/by/${id}`;
    fetch(API_URL + `${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          resp.data.profile.map((item) => {
            setFirstName1(item.firstname == null ? "NA" : item.firstname);
            setLastName(item.lastname == null ? "NA" : item.lastname);
            setPassword1(item.password == null ? "NA" : item.password);
            setEmail(item.email == null ? "NA" : item.email);
            setAddress1(item.address == null ? "NA" : item.address);
            setAddress2(item?.address2 == null ? "NA" : item.address2);
            setTelephone1(item.telephone == null ? "NA" : item.telephone);
            setCity(item.city == null ? "NA" : item.city);
            setAge(item.age == null ? "NA" : item.age);
            setGender(item.gender == null ? "NA" : item.gender);
            setBusiness(item.business == null ? "NA" : item.business);
            setPostalCode(item.zipcode == null ? "NA" : item.zipcode);
            getCountry(item.country);
            getState(item.country, item.state);
          });

          setDataload(false);
        });
      }
    });
  };
  const handleOwner = (event, id) => {
    setDataload(true);
    setOwnerId(id);
    setFirstName1("");
    setLastName("");
    setPassword1("");
    setEmail("");
    setAddress1("");
    setAddress2("");
    setTelephone1("");
    setCity("");
    setPostalCode("");
    setBusiness("");
    setAge("");
    setGender("");
    const params = { associated_owner: id };
    const url = `/get/owner/device/by/${id}`;
    fetch(API_URL + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          resp.data.profile.map((item) => {
            setFirstName1(item.firstname == null ? "NA" : item.firstname);
            setLastName(item.lastname);
            setPassword1(item.password == null ? "NA" : item.password);
            setEmail(item.email == null ? "NA" : item.email);
            setAddress1(
              item.address == null || item.address.length == 0
                ? "NA"
                : item.address
            );
            setAddress2(item.address2 == null ? "NA" : item.address2);
            setTelephone1(item.telephone == null ? "NA" : item.telephone);
            setCity(item.city == null ? "NA" : item.city);
            setAge(item.age == null ? "NA" : item.age);
            setGender(item.gender == null ? "NA" : item.gender);
            setBusiness(item.business == null ? "NA" : item.business);
            setStateId(item.state == null ? "NA" : item.state);
            setPostalCode(item.zipcode == null ? "NA" : item.zipcode);
            getCountry(item.country);
            getState(item.country, item.state);
          });
          setDataload(false);
        });
      }
    });
  };
  const getCountry = (countryid) => {
    setCountry("");
    if (countryid == "" || countryid == null) {
      setCountry("NA");
    } else {
      fetch(API_URL + "/countries", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        if (response.status == 200) {
          response.json().then((resp) => {
            resp.countries.map((item) => {
              if (item.id == countryid) {
                setCountry(item.name == null ? "NA" : item.name);
              }
            });
          });
        } else if (response.status == 401) {
          logout();
        } else {
          console.log("network error");
        }
      });
    }
  };

  const getState = (countryid, stateid) => {
    setState("");
    if (countryid == "" || stateid == null) {
      if (stateid == null || stateid == "") {
        setState("NA");
      } else if (stateid.includes("Choose States/Province")) {
        setState("NA");
      } else {
        setState(stateid);
      }
    } else if (stateid == "null") {
      setState(stateid);
    } else {
      fetch(API_URL + "/states?country_id=" + countryid, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        if (response.status == 200) {
          response.json().then((resp) => {
            resp.states.map((item) => {
              if (item.id == stateid) {
                setState(item.name);
              }
            });
          });
        } else if (response.status == 401) {
          logout();
        } else {
          console.log("network error");
        }
      });
    }
  };

  const SaveDevice = () => {
    let data = {};

    if (serialkey.current.value == " " || device_type.current.value == "null") {
      setErrorMessege(true);
      return false;
    } else if (confirmserialkey.current.value == "") {
      setErrorMessege(true);
      return false;
    }

    data["serial_key"] = validator.trim(serialkey.current.value);
    data["distributer"] = userid;
    data["device_type"] = device_type.current.value;
    data["c_module"] = cmoduleval;
    data["m_module"] = mmoduleval;

    if (serialkey.current.value == confirmserialkey.current.value) {
      fetch(API_URL + "/create/device", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then((response) => {
        if (response.status == 200) {
          response.json().then((resp) => {
            deviceToggleModal();
            successToggleModal();
            godevicelist();
            setCmoduleval(0);
            setMmoduleval(0);
          });
        } else if (response.status == 400) {
          devicekeyToggleModal();
        } else {
          alert("network error");
        }
      });
    } else {
      setConfirmKey(true);
      setConfirmpasserror("Serial key should match");
    }
  };

  const godevicelist = () => {
    setData([]);
    let type = localStorage.getItem("user_type");
    let id = localStorage.getItem("user_id");
    let url = "/get/go/device/list";
    if (type == 6) {
      let _url = "/get/go/device/list";
      const params = { distributer: id };
      const queryString = new URLSearchParams(params).toString();
      url = `${_url}?${queryString}`;
    } else if (type == 7 || type == 8) {
      if (dist) {
        if (dist == "all" && owner && !deviceType) {
          if (dist == "all" && owner == "all") {
            let _url = "/get/go/device/list";
            url = "/get/go/device/list";
          } else if (dist == "all" && owner == 0) {
            let _url = "/get/go/device/list/profile";
            const params = { type: owner };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else {
            let _url = "/get/go/device/list";
            const params = { owner: owner };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          }
        } else if (
          dist == "all" &&
          owner &&
          deviceType &&
          owner != "all" &&
          owner != 0 &&
          deviceType != "all"
        ) {
          let _url = "/get/go/device/list";
          const params = { owner: owner, device_type: deviceType };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        } else if (owner && !deviceType) {
          let _url = "/get/go/device/list";
          if (owner == "all") {
            const params = { distributer: dist };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (owner == "0") {
            if (!deviceType) {
              let _url = "/get/go/device/list/profile";
              const params = { distributer: dist, type: owner };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            } else {
            }
          } else {
            if (dist == null) {
              const params = { distributer: userid, owner: owner };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            } else {
              const params = { distributer: dist, owner: owner };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            }
          }
        } else if (dist && owner && deviceType) {
          if (dist == "all" && owner == "all" && deviceType == "all") {
            url = `/get/go/device/list`;
          } else if (
            dist != "all" &&
            owner != "all" &&
            owner != 0 &&
            deviceType != "all"
          ) {
            let _url = "/get/go/device/list";
            const params = {
              distributer: dist,
              owner: owner,
              device_type: deviceType,
            };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (
            dist != "all" &&
            owner != "all" &&
            owner != 0 &&
            deviceType == "all"
          ) {
            let _url = "/get/go/device/list";
            const params = { distributer: dist, owner: owner };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (dist != "all" && owner == "all" && deviceType != "all") {
            let _url = "/get/go/device/list";
            const params = { distributer: dist, device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (dist == "all" && owner == "all" && deviceType != "all") {
            let _url = "/get/go/device/list";
            const params = { device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (
            dist == "all" &&
            owner != "all" &&
            owner != 0 &&
            deviceType != "all"
          ) {
            let _url = "/get/go/device/list";
            const params = { owner: owner, device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (dist != "all" && owner == "all" && deviceType == "all") {
            let _url = "/get/go/device/list";
            const params = { distributer: dist };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (
            dist == "all" &&
            owner != "all" &&
            owner != 0 &&
            deviceType == "all"
          ) {
            let _url = "/get/go/device/list";
            const params = { owner: owner };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (dist != "all" && owner == 0 && deviceType != "all") {
            let _url = "/get/go/device/list/profile";
            const params = {
              distributer: dist,
              type: owner,
              device_type: deviceType,
            };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (dist != "all" && owner == 0 && deviceType == "all") {
            let _url = "/get/go/device/list/profile";
            const params = { distributer: dist, type: owner };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (dist == "all" && owner == 0 && deviceType != "all") {
            let _url = "/get/go/device/list/profile";
            const params = { type: owner, device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (dist == "all" && owner == 0 && deviceType == "all") {
            let _url = "/get/go/device/list/profile";
            const params = { type: owner };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else {
            let _url = "/get/go/device/list";
            const params = { device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          }
        } else if (dist != "all" && deviceType) {
          if (deviceType == "all") {
            let _url = "/get/go/device/list";
            const params = { distributer: dist };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else {
            let _url = "/get/go/device/list";
            const params = { distributer: dist, device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          }
        } else if (dist == "all" && !deviceType && !owner) {
          url = "/get/go/device/list";
        } else if (dist) {
          if (dist == "all") {
            if (dist == "all" && !owner && !deviceType) {
              let _url = "/get/go/device/list";
            } else if (dist == "all" && owner && !deviceType) {
              let _url = "/get/go/device/list";
              const params = { type: owner };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            } else if (dist == "all" && !owner && deviceType) {
              let _url = "/get/go/device/list";
              const params = { device_type: deviceType };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            } else if (dist == "all" && owner && deviceType) {
              let _url = "/get/go/device/list";
              const params = { type: owner, device_type: deviceType };
              const queryString = new URLSearchParams(params).toString();
              url = `${_url}?${queryString}`;
            }
          } else {
            let _url = "/get/go/device/list";
            const params = { distributer: dist };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          }
        }
      } else if (owner) {
        if (owner == "all" && dist && !deviceType) {
          let _url = "/get/go/device/list";
          const params = { distributer: dist };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        } else if (owner == "all" && dist && deviceType) {
          let _url = "/get/go/device/list";
          const params = { distributer: dist, device_type: deviceType };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        } else if (owner == "all" && !dist && deviceType) {
          if (deviceType == "all") {
            url = "/get/go/device/list";
          } else {
            let _url = "/get/go/device/list";
            const params = { device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          }
        } else if (owner == "all" && !deviceType && !dist) {
          url = "/get/go/device/list";
        } else if (dist && !deviceType) {
          let _url = "/get/go/device/list";
          const params = { owner: owner, distributer: dist };
          const queryString = new URLSearchParams(params).toString();
          url = `?${_url}${queryString}`;
        } else if (owner && deviceType && !dist) {
          if (owner == "all" && deviceType == "all") {
            let _url = "/get/go/device/list";
            const params = { device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (owner != "all" && owner != 0 && deviceType != "all") {
            let _url = "/get/go/device/list/profile";
            const params = { type: owner, device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else if (owner == 0 && deviceType != "all") {
            let _url = "/get/go/device/list/profile";
            const params = { type: owner, device_type: deviceType };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          } else {
            let _url = "/get/go/device/list";
            const params = { device_type: deviceType, owner: owner };
            const queryString = new URLSearchParams(params).toString();
            url = `${_url}?${queryString}`;
          }
        } else if (owner && deviceType && dist) {
          let _url = "/get/go/device/list";
          const params = {
            owner: owner,
            device_type: deviceType,
            distributer: dist,
          };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        } else if (owner == 0) {
          let _url = "/get/go/device/list/profile";
          const params = { type: owner };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        } else {
          let _url = "/get/go/device/list";
          const params = { owner: owner };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        }
      } else if (deviceType) {
        if (deviceType == "all" && !dist && !owner) {
          url = "/get/go/device/list";
        } else {
          let _url = "/get/go/device/list";
          const params = { device_type: deviceType };
          const queryString = new URLSearchParams(params).toString();
          url = `${_url}?${queryString}`;
        }
      }
    }
    fetch(API_URL + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          if (dist) {
            handleOwnerList(dist);
          } else if (dist == "all") {
            handleOwnerList(dist);
          }
          let check = "all";
          resp.length == 0
            ? navigation(`${location.pathname}` + "?dist=" + `${dist}`)
            : "";
          let _temp = [];
          resp.data.map((v, i) => {
            _temp.push({
              id: v.distributer,
              ownerid: v.owner_id,
              email: v.email,
              ownerfirstname: v.ownerfirstname,
              distributor:
                v.firstname != null
                  ? v.firstname + " " + v.lastname
                  : "No distributor name",
              ownername:
                v.ownerfirstname == null
                  ? v.email == null
                    ? "Not registered"
                    : v.email
                  : v.ownerfirstname + " " + v.ownerlastname,
              serialkey: v.serial_key,
              devicetype:
                v.device_type == "5"
                  ? "GO Personal" +
                    (v.c_module == 1 ? "(C)" : "") +
                    (v.m_module == 1 ? "(M)" : "")
                  : v.device_type == 6
                  ? "GO Basic"
                  : v.device_type == 7
                  ? "GO Professional"
                  : "No device type",
              dateactivate:
                v.date_activated == null
                  ? "Not activated"
                  : v.date_activated == 0
                  ? "NA"
                  : new Date(v.date_activated * 1000).toLocaleDateString(),
              created:
                v.created == null
                  ? "NA"
                  : v.created == 0
                  ? "NA"
                  : new Date(v.created).toLocaleDateString(),
              expires_at:
                v.expires_at == null
                  ? "Not expires_at"
                  : v.expires_at == 0
                  ? "NA"
                  : new Date(v.expires_at * 1000).toLocaleDateString(),
              download: v.downlaoded == 0 ? "No" : "Yes",

              action: (
                <ul className="action-list">
                  <li>
                    <Tooltip
                      classes={{
                        tooltip: classes.customTooltip,
                      }}
                      title="Registration History"
                      placement="top"
                    >
                      <a
                        href="javascript:void(0)"
                        onClick={() => viewdevicepopup(v.serial_key)}
                        className="view-patient"
                      >
                        <img src={logimg} />
                      </a>
                    </Tooltip>
                    {user_type != 6 && user_type != 8 ? (
                      <Tooltip
                        classes={{
                          tooltip: classes.customTooltip,
                        }}
                        title="Transfer Distributor"
                        placement="top"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={() =>
                            deChangeDistributor(
                              v.id,
                              v.serial_key,
                              v.distributer
                            )
                          }
                          className="view-patient"
                        >
                          <i className="fa fa-exchange" aria-hidden="true"></i>
                        </a>
                      </Tooltip>
                    ) : (
                      ""
                    )}

                    {v.date_activated == 0 ||
                    v.date_activated == null ||
                    localStorage.getItem("user_type") == 7 ? (
                      <>
                        {localStorage.getItem("user_type") != 8 && (
                          <Tooltip
                            classes={{
                              tooltip: classes.customTooltip,
                            }}
                            title="Edit"
                            placement="top"
                          >
                            <a
                              href="javascript:void(0)"
                              onClick={() => edittempopUp(v.id)}
                              className="view-patient"
                            >
                              <i
                                className="fa fa-pencil-square-o"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </Tooltip>
                        )}
                        {/* (v.expires_at == 0 || v.expires_at == null) && */}
                        {(localStorage.getItem("user_type") == 7 ||
                          localStorage.getItem("user_type") == 6) && (
                          <Tooltip
                            classes={{
                              tooltip: classes.customTooltip,
                            }}
                            title="Delete"
                            placement="top"
                          >
                            <a
                              href="javascript:void(0)"
                              onClick={() => deleteItempopUp(v.id)}
                              className="view-patient"
                            >
                              <i className="fa fa-trash" aria-hidden="true"></i>
                            </a>
                          </Tooltip>
                        )}{" "}
                      </>
                    ) : (
                      <>
                        {localStorage.getItem("user_type") != 8 && (
                          <Tooltip
                            classes={{
                              tooltip: classes.customTooltip,
                            }}
                            title="De-register"
                            placement="top"
                          >
                            <a
                              href="javascript:void(0)"
                              onClick={() =>
                                deRegisterpopup(v.id, v.serial_key)
                              }
                              className="view-patient"
                            >
                              <i
                                className="fa fa-user-times"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </Tooltip>
                        )}
                      </>
                    )}

                    {localStorage.getItem("user_type") == 7 && (
                      <Tooltip
                        classes={{
                          tooltip: classes.customTooltip,
                        }}
                        title="Update Device Expiry"
                        placement="top"
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={() =>
                            handleOpenExpiryModal(v.id, v.expires_at)
                          }
                          className="view-patient"
                        >
                          <i
                            class="fa-regular fa-calendar"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </Tooltip>
                    )}
                  </li>
                </ul>
              ),
            });
          });
          setFetchdata(false);
          setData(_temp);
        });
      }
    });
  };

  const deleteItempopUp = (id) => {
    if (deleteModal == false) {
      setDeviceid(id);
      setDeleteModal(!deleteModal);
    } else {
      setDeviceid(id);
      setDeleteModal(deleteModal);
    }
  };

  const edittempopUp = (id) => {
    if (editdeviceModal == false) {
      setDeviceid(id);
      setEditdeviceModal(!editdeviceModal);
    } else {
      setDeviceid(id);
      setEditdeviceModal(editdeviceModal);
    }
  };

  const viewdevicepopup = (key) => {
    setSerialkey(key);
    setViewdeviceModal(!ViewdeviceModal);
  };

  const viewlinkedpopup = (key) => {
    setSerialkey(key);
    setViewlinkedModal(!viewlinkedModal);
  };

  const deleteDevice = () => {
    fetch(API_URL + "/delete/device/" + deviceid, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          godevicelist();
          deleteToggleModal();
          deletesuccessToggleModal();
        });
      } else {
        alert("Network error");
      }
    });
  };

  const chackValidationserialkey = () => {
    if (serialkeyval != confirmserialkey.current.value) {
      setConfirmKey(true);
      setConfirmpasserror("Serial key should match");
      return false;
    } else {
      setConfirmpasserror("");
    }

    setConfirmSerialkeyval(confirmserialkey.current.value);
  };

  const HandleSerialkey = () => {
    if (confirmserialkey?.current?.value != serialkey.current.value) {
      setConfirmpasserror("Serial key should match");
    } else {
      setConfirmpasserror("");
    }

    setSerialkeyval(serialkey.current.value);

    var val = serialkey.current.value;
    if (val == 0) {
      setErrorMessege(true);
    } else {
      setErrorMessege(false);
    }
  };

  const HandledeviceType = (event) => {
    var val = device_type.current.value;

    setDevicetype(device_type.current.value);

    setCmoduleval(0);
    setMmoduleval(0);

    if (val == 5) {
      setCheckboxshow(true);
      setCheckingboxmessge(true);
    } else {
      setCheckboxshow(false);
      setCheckingboxmessge(false);
    }

    if (val == "null") {
      setErrorMessege(true);
    } else {
      setErrorMessege(false);
    }
  };

  const deRegisterpopup = (id, _serial) => {
    if (deregisterModal == false) {
      setDeviceid(id);
      setSelSerialKey(_serial);
      setDeregisterModal(!deregisterModal);
    } else {
      setDeviceid(id);
      setSelSerialKey(_serial);
      setDeregisterModal(deregisterModal);
    }
  };
  const editExpiryPopup = (id) => {
    setDeviceid(id);
    setOpenExpiryUpdateModal(!openExpiryUpdateModal);
  };

  const handleOpenExpiryModal = (deviceId, expiresAt) => {
    editExpiryPopup(deviceId);

    if (expiresAt && !isNaN(expiresAt)) {
      const date = new Date(expiresAt * 1000); // convert to ms
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      setSelectedDate(`${yyyy}-${mm}-${dd}`);
    } else {
      setSelectedDate(""); // blank if no expiry date
    }
  };

  const handleUpdateExpiry = async () => {
    const parsedDate = Date.parse(selectedDate); // milliseconds
    const expiryInSeconds = Math.floor(parsedDate / 1000);

    // Format to MM/DD/YYYY for display
    // const formattedDate = new Date(parsedDate).toLocaleDateString("en-US");

    try {
      const response = await fetch(API_URL + `/update/expiry/${deviceid}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ newExpiryDate: expiryInSeconds, type: "seven" }),
      });

      if (response.status === 200) {
        // const resp = await response.json();

        godevicelist();

        setDeviceid("");
        setOpenExpiryUpdateModal(false);
        setSelectedDate("");
        expirySuccessToggleModal();
      } else {
        throw new Error("Failed to update expiry date");
      }
    } catch (error) {
      console.error("Error updating expiry date:", error);
    }
  };

  const deChangeDistributor = (id, _serial, distributer) => {
    if (changeDistributorModal == false) {
      setDeviceid(id);
      setTransferDistributor(distributer);
      setchangeDistributorModal(!changeDistributorModal);
    } else {
      setDeviceid(id);
      setTransferDistributor(distributer);
      setchangeDistributorModal(changeDistributorModal);
    }
  };

  const deregister = () => {
    let data = {};

    data["serial_key"] = selSerialKey;
    data["user"] = userid;

    fetch(API_URL + "/add/device/seven/history/" + deviceid, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          godevicelist();
          deregistersuccessfulToggleModal();
          deregisterToggleModal();
        });
      } else if (response.status == 400) {
        devicekeyToggleModal();
      } else {
        alert("network error");
      }
    });
  };

  const columns = [
    {
      title: "id",
      field: "id",
      hidden: true,
    },

    {
      title: "email",
      field: "email",
      hidden: true,
    },
    {
      title: "ownerfirstname",
      field: "ownerfirstname",
      hidden: true,
    },

    {
      title: "Distributor",
      field: "distributor",
      cellStyle: {
        textTransform: "capitalize",
      },
      render: (rowData) =>
        rowData.distributor == "No distributor name" ? (
          "No distributor name"
        ) : (
          <Link
            className="pointer-curser"
            onClick={() => {
              handleDistributor(rowData.distributor, rowData.id);
              setdistributorDeviceModal(!distributorDeviceModal);
            }}
            style={{ color: "rgb(77, 0, 77)", cursor: "pointer" }}
          >
            {rowData.distributor}
          </Link>
        ),
    },
    {
      title: "Customer",
      field: "ownername",
      width: "200px",
      cellStyle: {
        textTransform: "capitalize",
      },
      customSort: (a, b) => {
        const customerA = a.ownername || a.email || "";
        const customerB = b.ownername || b.email || "";
        return customerA.localeCompare(customerB);
      },
      render: (rowData) =>
        rowData.ownerfirstname == null || rowData.ownerfirstname === "" ? (
          rowData.email == null ? (
            "Not registered"
          ) : (
            rowData.email
          )
        ) : (
          <Link
            className="pointer-cursor"
            onClick={() => {
              handleOwner(rowData.ownername, rowData.ownerid);
              setownerDeviceModal(!ownerDeviceModal);
            }}
            style={{ color: "rgb(77, 0, 77)", cursor: "pointer" }}
          >
            {rowData.ownername}
          </Link>
        ),
    },
    {
      title: "Serial Key",
      field: "serialkey",
    },

    {
      title: "Downloaded",
      field: "download",
    },
    {
      title: "Activation Date",
      field: "dateactivate",
      cellStyle: {
        textTransform: "capitalize",
      },
    },
    {
      title: "Creation Date",
      field: "created",
      cellStyle: {
        textTransform: "capitalize",
      },
    },
    {
      title: "Expiration Date",
      field: "expires_at",
      cellStyle: {
        textTransform: "capitalize",
      },
    },
    {
      title: "Device Type",
      field: "devicetype",
    },
    {
      title: <span className="text-right">Action</span>,
      field: "action",
    },
  ];

  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "",
  };

  const handleDistributorChange = (event) => {
    setFilterDist(event);
    if (event != null) {
      localStorage.setItem("distributor_change", event);
    } else {
      localStorage.setItem("distributor_change", id);
    }
    const params = new URLSearchParams(window.location.search);
    if (
      event == "all" &&
      params.size != 0 &&
      window.location.href.includes("dist=")
    ) {
      if (window.location.href.includes("owner=")) {
        const DoldValue = new URLSearchParams(window.location.search).get(
          "dist"
        );
        const newUrl = window.location.search.replace(
          `dist=${DoldValue}`,
          `dist=${event}`
        );
        navigation(`${location.pathname}` + `${newUrl}`);
      } else {
        const oldValue = new URLSearchParams(window.location.search).get(
          "dist"
        );
        const newValue = event;
        const newUrl = window.location.search.replace(
          `dist=${oldValue}`,
          `dist=${newValue}`
        );
        navigation(`${location.pathname}` + `${newUrl}`);
      }
    } else {
      if (
        window.location.href.includes("dist=") &&
        !window.location.href.includes("owner=") &&
        !window.location.href.includes("device_type=")
      ) {
        const oldValue = new URLSearchParams(window.location.search).get(
          "dist"
        );
        const newValue = event;
        const newUrl = window.location.search.replace(
          `dist=${oldValue}`,
          `dist=${newValue}`
        );
        navigation(`${location.pathname}` + `${newUrl}`);
      } else {
        const params = new URLSearchParams(window.location.search);
        if (params != 0) {
          dist = event;
          if (window.location.href.includes("dist=")) {
            const oldValue = new URLSearchParams(window.location.search).get(
              "dist"
            );
            if (window.location.href.includes("owner=")) {
              const queryParams = new URLSearchParams(window.location.search);
              queryParams.delete("owner");
              const updatedSearch = queryParams.toString();
              navigation(`${location.pathname}` + `?${updatedSearch}`);
              const newUrl = window.location.search.replace(
                `dist=${oldValue}`,
                `dist=${event}`
              );
              owner = "";
              navigation(`${location.pathname}` + `${newUrl}`);
            } else {
              const oldValue = new URLSearchParams(window.location.search).get(
                "dist"
              );
              const newUrl = window.location.search.replace(
                `dist=${oldValue}`,
                `dist=${event}`
              );
              navigation(`${location.pathname}` + `${newUrl}`);
            }
          } else {
            navigation(
              `${location.pathname}` + "?" + `${params}` + "&dist=" + `${event}`
            );
          }
        } else {
          navigation(`${location.pathname}` + "?dist=" + `${event}`);
        }
      }
    }
  };
  // const handleDistributorChange = (event) => {
  //     setFilterDist(event)
  //     if(event!= null){
  //         localStorage.setItem("distributor_change", event);
  //     }else{
  //     localStorage.setItem("distributor_change", id)
  //     }
  //     const params = new URLSearchParams(window.location.search);
  //     if (event == 'all' && params != 0 && window.location.href.includes("dist=")) {
  //         const oldValue = new URLSearchParams(window.location.search).get("dist");
  //         const newValue = event;
  //         const newUrl = window.location.href.replace(`dist=${oldValue}`, `dist=${newValue}`);
  //         window.location.href = newUrl;

  //     } else {
  //         if (window.location.href.includes("dist=")) {
  //             const oldValue = new URLSearchParams(window.location.search).get("dist");
  //             const newValue = event;
  //             const newUrl = window.location.href.replace(`dist=${oldValue}`, `dist=${newValue}`);
  //             window.location.href = "?dist=" + newValue;

  //         } else {
  //             const params = new URLSearchParams(window.location.search);
  //             if (params != 0) {
  //                 window.location.href = "?" + params + "&dist=" + event;
  //             } else {
  //                 window.location.href = "?dist=" + event;
  //             }

  //         }
  //     }
  // }
  const handleOwnerChange = (event) => {
    setFilterOwner(event);
    if (event != null) {
      localStorage.setItem("customer_change", event);
    }
    const params = new URLSearchParams(window.location.search);
    if (
      event == "all" &&
      params != 0 &&
      window.location.href.includes("owner=")
    ) {
      const oldValue = new URLSearchParams(window.location.search).get("owner");
      const newValue = event;
      const newUrl = window.location.search.replace(
        `owner=${oldValue}`,
        `owner=${newValue}`
      );
      navigation(`${location.pathname}` + `${newUrl}`);
    } else {
      if (window.location.href.includes("owner=")) {
        const oldValue = new URLSearchParams(window.location.search).get(
          "owner"
        );
        const newValue = event;
        const newUrl = window.location.search.replace(
          `owner=${oldValue}`,
          `owner=${newValue}`
        );
        navigation(`${location.pathname}` + `${newUrl}`);
      } else {
        if ("?" + params && params != 0) {
          owner = event;
          navigation(
            `${location.pathname}` + "?" + `${params}` + "&owner=" + `${event}`
          );
        } else {
          navigation(`${location.pathname}` + "?owner=" + `${event}`);
        }
      }
    }
  };
  const handleDeviceTypeChange = (event) => {
    if (event != null) {
      localStorage.setItem("Device_change", event);
    }
    const params = new URLSearchParams(window.location.search);
    if (
      event == "all" &&
      params != 0 &&
      window.location.href.includes("device_type")
    ) {
      const oldValue = new URLSearchParams(window.location.search).get(
        "device_type"
      );
      const newValue = event;
      const newUrl = window.location.search.replace(
        `device_type=${oldValue}`,
        `device_type=${newValue}`
      );
      navigation(`${location.pathname}` + `${newUrl}`);
    } else {
      if (window.location.href.includes("device_type")) {
        const oldValue = new URLSearchParams(window.location.search).get(
          "device_type"
        );
        const newValue = event;
        const newUrl = window.location.search.replace(
          `device_type=${oldValue}`,
          `device_type=${newValue}`
        );
        navigation(`${location.pathname}` + `${newUrl}`);
      } else {
        const params = new URLSearchParams(window.location.search);
        if (params != 0) {
          navigation(
            `${location.pathname}` +
              "?" +
              `${params}` +
              "&device_type=" +
              `${event}`
          );
        } else {
          navigation(`${location.pathname}` + "?device_type=" + `${event}`);
        }
      }
    }
  };
  const handleDistList = () => {
    let url = `/get/distributor/seven`;
    fetch(API_URL + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setDistList(resp.data);
        });
      }
    });
  };

  const handleOwnerList = (dist) => {
    let url = "";
    if (dist != "all") {
      let _url = "/get/customer/seven/device/list/data";
      const params = { distributor: dist };
      const queryString = new URLSearchParams(params).toString();
      url = `${_url}?${queryString}`;
    } else if (dist == "all") {
      url = `/get/owner/seven`;
    }
    fetch(API_URL + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setOwnerList(resp.data);
        });
      }
    });
  };
  const handleGoBack = () => {
    localStorage.removeItem("distributor_change");
    localStorage.removeItem("customer_change");
    localStorage.removeItem("Device_change");
    navigation("/");
  };
  const handleShowPassword = () => {
    setPassShow(!passShow);
  };

  return (
    <div className="">
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section">
          <div className="add-btn-wrp add-btn-wrp2">
            <div className="head-listing">
              <h3>Devices GO</h3>
              {user_type == 7 || user_type == 8 ? (
                <div
                  className="select-main-div"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="select-div">
                    <label>Filter By Distributor</label>
                    <select
                      className="select-tag"
                      onChange={(e) => handleDistributorChange(e.target.value)}
                    >
                      <option value="all">All</option>
                      {distList.length > 0 &&
                        distList
                          .filter(
                            (item, index, self) =>
                              self.findIndex(
                                (t) =>
                                  t.firstname === item.firstname &&
                                  t.lastname === item.lastname
                              ) === index
                          )
                          .map((item) => {
                            if (!item.firstname || !item.lastname) return null;
                            return (
                              <option
                                key={item.eid}
                                value={item.eid}
                                selected={item.eid == dist ? "selected" : ""}
                              >
                                {item.firstname} {item.lastname}
                              </option>
                            );
                          })}
                    </select>
                  </div>
                  <div className="select-div">
                    <label>Filter By Customer</label>
                    <select
                      className="select-tag"
                      onChange={(e) => handleOwnerChange(e.target.value)}
                    >
                      <option value="all">All</option>
                      <option value="0" selected={owner == 0 ? "selected" : ""}>
                        Not Registered
                      </option>
                      {ownerList.length > 0 &&
                        ownerList
                          .filter(
                            (item, index, self) =>
                              self.findIndex(
                                (t) =>
                                  t.firstname === item.firstname &&
                                  t.lastname === item.lastname
                              ) === index
                          )
                          .map((item) => {
                            if (!item.firstname || !item.lastname) return null;
                            return (
                              <option
                                key={item.eid}
                                value={item.eid}
                                selected={item.eid == owner ? "selected" : ""}
                              >
                                {item.firstname} {item.lastname}
                              </option>
                            );
                          })}
                    </select>
                  </div>
                  <div
                    className="select-div"
                    style={{ width: "100px !important" }}
                  >
                    <label>Filter By Device type</label>
                    <select
                      className="select-tag"
                      onChange={(e) => handleDeviceTypeChange(e.target.value)}
                      style={{ width: "100px !important" }}
                    >
                      <option value="all">All</option>
                      <option
                        value="5"
                        selected={deviceType == 5 ? "selecetd" : ""}
                      >
                        GO Personal
                      </option>
                      <option
                        value="8"
                        selected={deviceType == 8 ? "selecetd" : ""}
                      >
                        GO Personal(M)
                      </option>
                      <option
                        value="9"
                        selected={deviceType == 9 ? "selecetd" : ""}
                      >
                        GO Personal(C)
                      </option>
                      <option
                        value="6"
                        selected={deviceType == 6 ? "selecetd" : ""}
                      >
                        GO Basic
                      </option>
                      <option
                        value="7"
                        selected={deviceType == 7 ? "selecetd" : ""}
                      >
                        GO Professional
                      </option>
                    </select>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="add-btn">
              <button onClick={handleGoBack} style={{ marginBottom: "15px" }}>
                Go Back
              </button>
              {user_type != 8 && (
                <button
                  onClick={() => {
                    deviceToggleModal();
                    setCheckboxshow(false);
                    setCheckingboxmessge(false);
                  }}
                >
                  Add Device Serial
                </button>
              )}
            </div>
          </div>
          <div className="wrp-bankform">
            <div className="mobiletable">
              <div style={{ maxWidth: "100%" }}>
                {fetchdata ? (
                  <div className="norecordfound">Fetching record</div>
                ) : (
                  data.length > 0 && (
                    <MaterialTable
                      options={{
                        filter: true,
                        sorting: true,
                        filterType: "dropdown",
                        responsive: "",
                        search: true,
                        showTitle: false,
                        pageSize:
                          data?.length <= 5
                            ? 5
                            : data?.length > 5 && data?.length <= 10
                            ? 10
                            : data?.length > 10 && data?.length <= 20
                            ? 20
                            : data?.length > 20 && data?.length <= 30
                            ? 30
                            : data?.length > 30 && data?.length <= 40
                            ? 40
                            : data?.length > 40 && data?.length <= 50
                            ? 50
                            : data?.length > 50 && data?.length <= 100
                            ? 100
                            : 150,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                      }}
                      columns={columns}
                      data={data}
                      pagination={true}
                    />
                  )
                )}
                {fetchdata
                  ? ""
                  : data.length == 0 && (
                      <MaterialTable
                        options={{
                          showTitle: false,
                        }}
                        columns={columns}
                        showTitle={false}
                        pagination={true}
                      />
                    )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={distributorDeviceModal}
        toggle={distributorDeviceToggleModal}
        className="connect-box1"
        centered={true}
      >
        <ModalHeader toggle={distributorDeviceToggleModal}>
          Distributor Profile
        </ModalHeader>

        {dataload ? (
          <div className="loader12"></div>
        ) : (
          <div
            style={{ borderBottom: "1px solid #212529", paddingBottom: "40px" }}
          >
            <div className="row-main" style={{ padding: "0 15px" }}>
              <div className="row pt-3">
                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                  <div>
                    <div>
                      <div className="modal_p">
                        <p className="font14 heading_p"> First Name : </p>
                        <p className="font14">{firstName1} </p>
                      </div>
                      <div className="modal_p">
                        <p className="font14 heading_p"> Last Name : </p>
                        <p className="font14">{lastName} </p>
                      </div>

                      <div className="modal_p">
                        <p className="font14 heading_p"> Email : </p>
                        <p className="font14 add_p">
                          {email != "NA" ? email : "NA"}
                        </p>
                      </div>
                      {user_type != 8 && (
                        <div className="modal_p">
                          <p className="font14 heading_p"> Password : </p>
                          {password1 != "NA" ? (
                            <p
                              className="font14"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "35px",
                              }}
                            >
                              {passShow ? (
                                password1
                              ) : (
                                <div style={{ display: "flex" }}>
                                  {[...Array(password1.length)].map(
                                    (_, index) => (
                                      <div key={index} className="ball" />
                                    )
                                  )}
                                </div>
                              )}
                              <i
                                className={
                                  passShow
                                    ? "fa-solid fa-eye eyeColor"
                                    : "fa-solid fa-eye-slash eyeColor"
                                }
                                onClick={handleShowPassword}
                              ></i>
                            </p>
                          ) : (
                            <p
                              className="font14"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "35px",
                              }}
                            >
                              {password1}
                            </p>
                          )}
                        </div>
                      )}
                      <div className="modal_p">
                        <p className="font14 heading_p"> Telephone : </p>
                        <p className="font14">
                          {telephone1 != "NA" ? telephone1 : "NA"}
                        </p>
                      </div>
                      {user_type != 8 && (
                        <div className="modal_p">
                          <p className="font14 heading_p"> Age : </p>
                          <p className="font14"> {age} </p>
                        </div>
                      )}
                      {user_type != 8 && (
                        <div className="modal_p">
                          <p className="font14 heading_p">
                            {" "}
                            Name of Business :{" "}
                          </p>
                          <p className="font14 add_p">
                            {" "}
                            {business.length == 0 ? "NA" : business}
                          </p>
                        </div>
                      )}
                    </div>
                    <div></div>
                  </div>
                </div>
                {user_type == 8 ? (
                  <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <div className="modal_p">
                      <p className="font14 heading_p"> Gender : </p>
                      <p className="font14"> {gender}</p>
                    </div>
                    <div className="modal_p">
                      <p className="font14 heading_p"> Country : </p>
                      <p className="font14">{country}</p>
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <div>
                      <div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> City : </p>
                          <p className="font14">{city}</p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Postal Code : </p>
                          <p className="font14">
                            {postalCode.length == 0 ? "NA" : postalCode}
                          </p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Gender : </p>
                          <p className="font14"> {gender}</p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Country : </p>
                          <p className="font14">{country}</p>
                        </div>

                        <div className="modal_p ">
                          <p className="font14 heading_p"> State : </p>
                          <p className="font14">
                            {" "}
                            {state.length == 0 ? "NA" : state}
                          </p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Address 1 :</p>
                          <p className="font14 add_p">{address1}</p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Address 2 : </p>
                          <p className="font14 add_p">
                            {address2.length == 0 ? "NA" : address2}
                          </p>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <ModalBody>
          <div className="add-btn-wrp add-btn-wrp2">
            <div className="button-div">
              <Accordion className="main-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device GO</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <GoDeviceDistributors id={distId} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion className="main-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device 6.0</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <GoDeviceAccordian6 id={distId} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion className="main-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device 5.0</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <GoDeviceAccordian5 id={distId} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={ownerDeviceModal}
        toggle={ownerDeviceToggleModal}
        className="connect-box1"
        centered={true}
      >
        <ModalHeader toggle={ownerDeviceToggleModal}>
          Customer Profile
        </ModalHeader>
        {dataload ? (
          <div className="loader12"></div>
        ) : (
          <div
            style={{ borderBottom: "1px solid #212529", paddingBottom: "40px" }}
          >
            <div className="row-main" style={{ padding: "0 15px" }}>
              <div className="row pt-3">
                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                  <div>
                    <div>
                      <div className="modal_p">
                        <p className="font14 heading_p"> First Name : </p>
                        <p className="font14">{firstName1} </p>
                      </div>
                      <div className="modal_p">
                        <p className="font14 heading_p"> Last Name : </p>
                        <p className="font14">{lastName} </p>
                      </div>

                      <div className="modal_p">
                        <p className="font14 heading_p"> Email : </p>
                        <p className="font14 add_p">
                          {email != "NA" ? email : "NA"}
                        </p>
                      </div>
                      {localStorage.getItem("user_type") == 7 && (
                        <div className="modal_p">
                          <p className="font14 heading_p"> Password : </p>
                          {password1 != "NA" ? (
                            <p
                              className="font14"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "35px",
                              }}
                            >
                              {passShow ? (
                                password1
                              ) : (
                                <div style={{ display: "flex" }}>
                                  {[...Array(password1.length)].map(
                                    (_, index) => (
                                      <div key={index} className="ball" />
                                    )
                                  )}
                                </div>
                              )}
                              <i
                                className={
                                  passShow
                                    ? "fa-solid fa-eye eyeColor"
                                    : "fa-solid fa-eye-slash eyeColor"
                                }
                                onClick={handleShowPassword}
                              ></i>
                            </p>
                          ) : (
                            <p
                              className="font14"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "35px",
                              }}
                            >
                              {password1}
                            </p>
                          )}
                        </div>
                      )}
                      <div className="modal_p">
                        <p className="font14 heading_p"> Telephone : </p>
                        <p className="font14">
                          <p className="font14">
                            {telephone1 != "NA" ? telephone1 : "NA"}
                          </p>
                        </p>
                      </div>
                      {user_type != 8 && (
                        <div className="modal_p">
                          <p className="font14 heading_p"> Age : </p>
                          <p className="font14"> {age} </p>
                        </div>
                      )}
                      {user_type != 8 && (
                        <div className="modal_p">
                          <p className="font14 heading_p">
                            {" "}
                            Name of Business :{" "}
                          </p>
                          <p className="font14 add_p">
                            {" "}
                            {business.length == 0 ? "NA" : business}
                          </p>
                        </div>
                      )}
                    </div>
                    <div></div>
                  </div>
                </div>

                {user_type == 8 ? (
                  <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <div className="modal_p">
                      <p className="font14 heading_p"> Gender : </p>
                      <p className="font14"> {gender}</p>
                    </div>
                    <div className="modal_p">
                      <p className="font14 heading_p"> Country : </p>
                      <p className="font14">{country}</p>
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <div>
                      <div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> City : </p>
                          <p className="font14">
                            {city.length == 0 ? "NA" : city}
                          </p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Postal Code : </p>
                          <p className="font14">
                            {postalCode.length == 0 ? "NA" : postalCode}
                          </p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Gender : </p>
                          <p className="font14"> {gender}</p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Country : </p>
                          <p className="font14">{country}</p>
                        </div>

                        <div className="modal_p ">
                          <p className="font14 heading_p"> State : </p>
                          <p className="font14"> {state}</p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Address 1 :</p>
                          <p className="font14 add_p">{address1}</p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Address 2 : </p>
                          <p className="font14 add_p">
                            {address2.length == 0 ? "NA" : address2}
                          </p>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <ModalBody>
          <div className="add-btn-wrp add-btn-wrp2">
            <div className="button-div">
              <Accordion className="main-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device GO</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <GoDeviceOwner id={ownerId} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion className="main-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device 6.0</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <GoDeviceOwnerAcc6 id={ownerId} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion className="main-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device 5.0</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <GodeviceOwnerAccordian5 id={ownerId} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={deviceModal}
        toggle={deviceToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={deviceToggleModal}>
          <span className="ml-1 roititle ">Add</span>
        </ModalHeader>
        <ModalBody>
          <div>
            <ul className="deviceformlist">
              <li>
                <div className="input-group mb-3 w-100 device-input">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      GO-
                    </span>
                  </div>
                  <input
                    type="number"
                    placeholder="Write serial key"
                    ref={serialkey}
                    onChange={HandleSerialkey}
                  />
                </div>
                <div className="input-group mb-3 w-100 device-input">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      GO-
                    </span>
                  </div>

                  <input
                    type="number"
                    placeholder="Confirm serial key"
                    ref={confirmserialkey}
                    onChange={chackValidationserialkey}
                  />
                </div>
                {confirmKey && (
                  <p className="passworderror">{confirmpasserror}</p>
                )}
                <div className="select-device-type">
                  <select ref={device_type} onChange={HandledeviceType}>
                    <option value="null" className="option-select">
                      Select device type
                    </option>
                    <option value="5" className="option-select">
                      GO Personal
                    </option>
                    <option value="6" className="option-select">
                      GO Basic
                    </option>
                    <option value="7" className="option-select">
                      GO Professional
                    </option>
                  </select>

                  {checkboxshow && (
                    <div className="wrp-checkbox-module">
                      <input
                        type="checkbox"
                        onChange={HandleCmodule}
                        ref={cmodule}
                      />
                      <label className="c_module">C module</label>{" "}
                      <input
                        type="checkbox"
                        onChange={HandlemModule}
                        className="mrl-module"
                        ref={m_module}
                      />{" "}
                      <label>M module</label>
                    </div>
                  )}

                  {cmoduleval == 1 &&
                  mmoduleval == 1 &&
                  devicetype == 5 &&
                  checkingboxmessge == true ? (
                    <p>
                      Please note that checking off C-module and M-module
                      checkboxes together will make this a GO Basic device.
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                {errorMessege && (
                  <p className="error-message">All required field</p>
                )}
              </li>

              <li>
                <div className="addBtn">
                  <button onClick={SaveDevice}>Add</button>
                </div>
              </li>
            </ul>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={successModal}
        toggle={successToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={successToggleModal}>
          <span className="ml-1 roititle ">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Serial key has been added successfully</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={expirySuccessModal}
        toggle={expirySuccessToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={expirySuccessToggleModal}>
          <span className="ml-1 roititle ">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Expiry date has been updated successfully</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={deleteModal}
        toggle={deleteToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalBody>
          <div className="deletemodal-content">
            <h6>
              <i
                onClick={() => setDeleteModal(false)}
                className="fa fa-times"
                aria-hidden="true"
              ></i>
            </h6>
            <div className="deleteCircle">
              <i className="fa fa-trash" aria-hidden="true"></i>
            </div>
            <h3>Are you sure?</h3>
            <p className="para">
              Do you really want to delete the record? This process cannot be
              undone.
            </p>

            <div className="butn-wrp">
              <button className="delete-cancel-btn" onClick={deleteToggleModal}>
                Cancel
              </button>
              <button onClick={deleteDevice}>Delete</button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={deletesuccessModal}
        toggle={deletesuccessToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={deletesuccessToggleModal}>
          <span className="ml-1 roititle ">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Serial Key has been deleted successfully</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={editdeviceModal}
        toggle={editdeviceToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={editdeviceToggleModal}>
          <span className="ml-1 roititle ">Edit</span>
        </ModalHeader>
        <ModalBody>
          <EditDevice
            deviceid={deviceid}
            editdeviceToggleModal={editdeviceToggleModal}
            successeditdeviceToggleModal={successeditdeviceToggleModal}
            godevicelist={godevicelist}
            devicekeyToggleModal={devicekeyToggleModal}
          />
        </ModalBody>
      </Modal>

      <Modal
        isOpen={successeditdeviceModal}
        toggle={successeditdeviceToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={successeditdeviceToggleModal}>
          <span className="ml-1 roititle ">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Device type has been updated successfully</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={devicekeyModal}
        toggle={devicekeyToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={devicekeyToggleModal}>
          <span className="ml-1 roititle ">Error</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>A device already exists with this Serial key.</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={deregisterModal}
        toggle={deregisterToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={deregisterToggleModal}>
          <span className="ml-1 roititle ">De-register</span>
        </ModalHeader>
        <ModalBody>
          <div className="deletemodal-content">
            <p className="para">
              Do you really want to de-register this device?
            </p>

            <div className="butn-wrp">
              <button
                className="delete-cancel-btn"
                onClick={deregisterToggleModal}
              >
                No
              </button>
              <button
                style={{ backgroundColor: "rgb(77, 0, 77)" }}
                onClick={deregister}
              >
                Yes
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={changeDistributorModal}
        toggle={changeDistributorToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={changeDistributorToggleModal}>
          <span className="ml-1 roititle ">Transfer Distributor</span>
        </ModalHeader>
        <ModalBody>
          <ChangeDistributor7
            deviceid={deviceid}
            distributor={transferDistributor}
            changeDistributorToggleModal={changeDistributorToggleModal}
            successechangedeviceModal={successechangedeviceModal}
            godevicelist={godevicelist}
            handleDistList={handleDistList}
            deviceCount={data?.length}
          />
        </ModalBody>
      </Modal>

      <Modal
        isOpen={changedeviceModal}
        toggle={successechangedeviceModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={successechangedeviceModal}>
          <span className="ml-1 roititle ">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>
              Device has been successfully transferred to the selected
              distributor
            </p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={deregistersuccessfulModal}
        toggle={deregistersuccessfulToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={deregistersuccessfulToggleModal}>
          <span className="ml-1 roititle ">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Device Successfully de-registered</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={ViewdeviceModal}
        toggle={viewdeviceToggleModal}
        className="viewlog"
        centered={true}
      >
        <ModalHeader toggle={viewdeviceToggleModal}>
          <span className="ml-1 roititle ">Device seven history list</span>
        </ModalHeader>
        <ModalBody>
          <Viewlog serialkeyes={serialkeyes} />
        </ModalBody>
      </Modal>

      <Modal
        isOpen={viewlinkedModal}
        toggle={ViewlinkedToggleModal}
        className="viewlog"
        centered={true}
      >
        <ModalHeader toggle={ViewlinkedToggleModal}>
          <span className="ml-1 roititle ">Device seven history list</span>
        </ModalHeader>
        <ModalBody>
          <Viewlinkedlog serialkeyes={serialkeyes} />
        </ModalBody>
      </Modal>

      <Modal
        isOpen={openExpiryUpdateModal}
        toggle={openExpiryUpdateToggleModal}
        className="viewlog"
        centered={true}
      >
        <ModalHeader toggle={openExpiryUpdateToggleModal}>
          <span className="ml-1 roititle">Update Device Expiry</span>
        </ModalHeader>
        <ModalBody>
          <div className="mb-3 px-1">
            <label htmlFor="expiryDate" className="form-label fw-bold mb-2">
              Select Expiry Date
            </label>
            <input
              type="date"
              id="expiryDate"
              name="expiryDate"
              className="form-control custom-date-input"
              value={selectedDate}
              min={new Date().toISOString().split("T")[0]} // Prevent past dates
              onChange={(e) => setSelectedDate(e.target.value)}
              placeholder="dd-mm-yy"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-secondary"
            onClick={openExpiryUpdateToggleModal}
          >
            Cancel
          </button>
          <button
            onClick={handleUpdateExpiry}
            style={{
              backgroundColor: "dodgerblue",
              color: "white",
              border: "none",
              padding: "7px 20px",
              borderRadius: "5px",
            }}
          >
            Update Expiry
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Godevices;
